export interface CreateParticleLoopStateOptions {
  length: number;
  period: number;
  phaseOffset: number;
  radius?: number;
}

export interface ParticleLoopState {
  length: number;
  period: number;
  phaseOffset: number;
  radius: number;
}

export interface ParticleFrameState {
  progress: number;
  distance: number;
  radius: number;
  opacity: number;
}

const getLoopProgress = (elapsedMs: number, period: number, phaseOffset: number) => {
  const safePeriod = Math.max(period, 1);
  const looped = ((elapsedMs + phaseOffset) % safePeriod + safePeriod) % safePeriod;

  return looped / safePeriod;
};

export const createParticleLoopState = ({
  length,
  period,
  phaseOffset,
  radius = 4,
}: CreateParticleLoopStateOptions): ParticleLoopState => {
  return {
    length: Math.max(length, 1),
    period: Math.max(period, 1),
    phaseOffset,
    radius,
  };
};

export const getParticleFrameState = (
  state: ParticleLoopState,
  elapsedMs: number,
): ParticleFrameState => {
  const progress = getLoopProgress(elapsedMs, state.period, state.phaseOffset);

  let opacity = 1;

  if (progress < 0.15) {
    opacity = progress / 0.15;
  } else if (progress > 0.85) {
    opacity = (1 - progress) / 0.15;
  }

  return {
    progress,
    distance: progress * state.length,
    radius: Math.max(1, state.radius * (1 - progress * 0.75)),
    opacity,
  };
};
